<template>
    <menu class="menu-frame" :class="$store.state.isMenuOpen ? 'menu-frame--opened' : ''" id="menu-frame">

        <div class="menu-frame__inner">
            <div class="two-column">

                <div class="two-column__column">
                    
                    <a class="link">
                        <span class="link--menu link--outer accent--gradient">Scientific Resort</span>
                    
                        <span class="link__text grey2">Longevity Scientific Resort - opening in 2025</span>
                        <span class="link__text indigo">A Scientific resort in maldives: Researching longevity while get time off with professional treatment</span>
                    </a>

                    <a class="link">
                        <span class="link--menu link--outer accent--gradient">Petition</span>
                    
                        <span class="link__text grey2">Longevity Petition</span>
                        <span class="link__text indigo">Help us get state-level support for Anti-aging researches</span>
                    </a>

                    <a class="link">
                        <span class="link--menu link--outer accent--gradient">For Business & investors</span>
                    </a>

                    <a class="link">
                        <span class="link--menu link--outer accent--gradient">Patents</span>
                    </a>

                </div>

                <div class="two-column__column">
                    <a class="link">
                        <span class="link--menu link--outer accent--gradient">Blog</span>
                    </a>
                    
                    <a class="link">
                        <span class="link--menu indigo">Crypto</span>
                    </a>

                
                    <ul class="submenu-links-list">
                        <li>
                            <a class="link link--submenu link--outer indigo">
                                NFTs & Marketplace
                            </a>
                        </li>
                        <li>
                            <a class="link link--submenu link--outer indigo">
                                LongevityCoin ($LONG)
                            </a>
                        </li>
                    </ul>
                

                    <a class="link link--submenu link--outer indigo">
                        Terms of use
                    </a>
                    
                    <a class="link link--submenu link--outer indigo">
                        privacy policy
                    </a>

                    <a class="link link--submenu link--outer indigo">
                        Press
                    </a>

                </div>
            </div>

            <div class="menu-frame__footer">

                <div class="app-buttons">
                    <a href="#" class="app-buttons__button">
                        <img src="../assets/img/svg/google.svg" />
                    </a>
                    <a href="#" class="app-buttons__button">
                        <img src="../assets/img/svg/apple.svg" />
                    </a>
                </div>

                <div class="flex contact-links">
                    <div class="contact-links__buttons flex">
                        <a href="mailto:contact@intime.digital" class="contact-links__email">
                            <img src="../assets/img/svg/envelope.svg" />
                            <span>contact@intime.digital</span>
                        </a>

                        <a href="https://intime.digital/en/web/contact/" class="contact-links__submit">Send a message</a>
                    </div>

                    <div class="social-links flex">
                        <a href="https://twitter.com/TETERINOLEG">
                            <img src="../assets/img/social-icons/twitter.svg" /></a>
                        
                        <a href="https://www.facebook.com/LongActiveLifeInTime/">
                            <img src="../assets/img/social-icons//facebook.svg" /></a>
                        
                        <a href="https://www.linkedin.com/in/olegteterin/">
                            <img src="../assets/img/social-icons/linked_in.svg" /></a>
                        
                        <a href="https://www.instagram.com/teterinolegjr/">
                            <img src="../assets/img/social-icons/instagram.svg" /></a>
                        
                        <a href="https://t.me/LongevityInTime">
                            <img src="../assets/img/social-icons/telegram.svg" /></a>
                    </div>
                </div>

            </div>
        </div>
    </menu>

</template>

<script>
export default {
    name: 'MenuModal',
    data() {
		return {
            isMenuOpen: this.$store.state.isMenuOpen
		}
	},
    methods: {
        switchMenu (value) {
			this.$store.commit('switchMenuState', !this.isMenuOpen)
		}
    }
}
</script>

<style lang="scss" scoped>
@import '../colors.scss';
@import '../mixins.scss';

.menu-frame {
	position: absolute;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	background-color: #fff;
	z-index: -10;
    top: -200%;
    left: 0;
	padding-top: 8%;
	transition: all .3s ease-in-out;

    &:after {
		content: '';
		display: block;
		width: 100vw;
		height: 100vh;
		position: absolute;
		top: 15%;
		left: -5%;
		background-image: url('../assets/img/svg/back_pattern.svg');
		background-repeat: no-repeat;
		background-size: 100%;
	}

	@include mobile {
		height: auto;
		padding-top: 54%;
        padding-bottom: 15%;
	}
	
    &__inner {
        padding: 0% 7.7%;
    }

	&__footer {
        display: flex;
        justify-content: space-between;

        @include mobile {
            flex-direction: column;
        }
        .contact-links {
            flex-basis: 44%;
            display: flex;
            flex-direction: column;
            margin: 0px;
            align-items: center;

            &__buttons {
                @include mobile {
                    flex-direction: column;
                    align-items: center;
                }
            }

            .social-links {
                margin-top: 48px;
            }
        }
    }

	&--opened {
		z-index: 40;
		top: 0%;
        position: fixed;
        transition: all .3s ease-in-out;
	}

    .two-column {
        margin-bottom: 0;
    }

	.button--close {
		right: 7.8%;
        z-index: 42;
	}

	.link {
		margin-bottom: 8%;

		&__text {
			font-weight: 400;
			font-size: 20px;
			line-height: 26px;
			max-width: 70%;
			text-transform: capitalize;

            @include mobile {
                font-size: 16px;
                line-height: 21px;
                max-width: 100%;
			}
		}
		
		span {
			display: block;
		}	
	}

	.submenu-links-list {
		list-style: none;
		padding-left: 30px;
		margin-bottom: 48px;
		border-left: 3px solid $accent;
		margin-top: -50px;


		// add showing on click
		@include mobile {
			display: none;
		}

		li {
			margin-bottom: 24px;
			&:last-child {
				margin: 0;
			}
		}
	}
}

</style>